import { createFileRoute } from '@tanstack/react-router'
import { requireAdminOrSuperAdmin } from '@/lib/auth-guards'
import { RepeatedCheckInsTab } from '@/features/dashboard/tabs/repeated-check-ins-tab'

export const Route = createFileRoute(
  '/_authenticated/dashboard/repeated-check-ins'
)({
  beforeLoad: requireAdminOrSuperAdmin,
  component: RepeatedCheckInsTab,
})
